import React from 'react'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import { getThemeClassName } from 'lib/theme/themeUtils'
import TextButton from 'LuxKit/Button/TextButton'
import { CRUISE_ROUTES } from 'constants/cruise'

interface Props {
  offerList: App.OfferList
}

function CruisePageFlashOffersCarousel({ offerList }: Props) {
  if (!offerList.fetching && !offerList.offerIds.length) return null

  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <Group gap={16} direction="horizontal" horizontalAlign="space-between">
        <Heading variant="heading2">Today’s top <i>cruise</i> offers</Heading>
        <TextButton kind="tertiary" to={`${CRUISE_ROUTES.SEARCH_PAGE}`}>View More</TextButton>
      </Group>
    </LayoutContainer>

    <OfferListCarousel
      tileStyle="card-default"
      tileSize="medium"
      overrideOfferList={offerList}
      className={getThemeClassName({ desktop: 'default' })}
    />
  </Group>
}

export default CruisePageFlashOffersCarousel
